import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import allAxiosCommonRequest from '../axiosComponent/allAxiosCommonRequest';

const ContainerSize = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [containerSize, setContainerSize] = useState([]);
  const [isloading, setisloading] = useState(false);
  useEffect(() => {
    allAxiosCommonRequest({url : 'masters/container_type', method: 'get'})
    .then((response)=>{
        console.log("---------------------------------",'container size')
        console.log(response.data)
        setContainerSize(response.data.resultSet);
    })
    .catch((error) => console.log(error));
}, []);


  let containerSizeOptions = [];
  if (containerSize.length > 0) {
    containerSize.map((object, index) => {
      let temp = {};
      temp.key = object.containerTypeCode;
      temp.text = object.containerType;
      temp.value = object.containerTypeId;
      temp.raw = { ...object };
      return (containerSizeOptions[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
  };
  return (
    <div className="">
      <Dropdown
        selection
        clearable
        loading={isloading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={containerSizeOptions}
        {...props}
      />
    </div>
  );
};

export default ContainerSize;
